<template>
	<router-view></router-view>
</template>

<script>

export default {
	name: "ResourcesPage",
}
</script>

<style scoped>

</style>